import { render, staticRenderFns } from "./OptionalRouterLink.vue?vue&type=template&id=53f67495"
import script from "./OptionalRouterLink.vue?vue&type=script&lang=js"
export * from "./OptionalRouterLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports